const CustomInput = ({ placeholder, label, onChange, value, defaultValue }) => {
  return (
    <label className="checkoutCustomInput">
      <span>{label}</span>
      <input
        value={value}
        className="custom-input-field"
        placeholder={placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
      />
    </label>
  );
};

export default CustomInput;
